import { render, staticRenderFns } from "./HsNewStudents.vue?vue&type=template&id=1700e6c6&"
import script from "./HsNewStudents.vue?vue&type=script&lang=js&"
export * from "./HsNewStudents.vue?vue&type=script&lang=js&"
import style0 from "./HsNewStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports